import { render, staticRenderFns } from "./ShofurHelp.vue?vue&type=template&id=37f1cada&scoped=true"
var script = {}
import style0 from "./ShofurHelp.vue?vue&type=style&index=0&id=37f1cada&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f1cada",
  null
  
)

export default component.exports